var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoModernView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.992248 0.5C0.444245 0.5 0 0.833183 0 1.24419V7.19767C0 7.60868 0.444245 7.94186 0.992248 7.94186H9.42636C9.97436 7.94186 10.4186 7.60868 10.4186 7.19767V1.24419C10.4186 0.833183 9.97436 0.5 9.42636 0.5H0.992248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.744186 8.68604C0.509327 8.68604 0 9.01922 0 9.43022V15.3837C0 15.7947 0.509327 16.1279 0.744186 16.1279H3.72093C3.95579 16.1279 4.46512 15.7947 4.46512 15.3837V9.43022C4.46512 9.01922 3.95579 8.68604 3.72093 8.68604H0.744186Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2789 0.5C12.044 0.5 11.5347 0.833183 11.5347 1.24419V7.19767C11.5347 7.60868 12.044 7.94186 12.2789 7.94186H15.2556C15.4905 7.94186 15.9998 7.60868 15.9998 7.19767V1.24419C15.9998 0.833183 15.4905 0.5 15.2556 0.5H12.2789Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57379 8.68604C6.02579 8.68604 5.58154 9.01922 5.58154 9.43022V15.3837C5.58154 15.7947 6.02579 16.1279 6.57379 16.1279H15.0079C15.5559 16.1279 16.0001 15.7947 16.0001 15.3837V9.43022C16.0001 9.01922 15.5559 8.68604 15.0079 8.68604H6.57379Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoModernView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_modern_view.e9ab675e69a522e02e18e0b5154c1d60.svg";